export default class StringUtil {
    constructor() { }
    static isTelNo(value) {
        const regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/);
        return regexp.test(value);
    }
    static isMailAddress(value) {
        const regexp = new RegExp(/^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/);
        return regexp.test(value);
    }
}
